import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import Config from "app/Config";

const TroubleshootingStep = ({processContent, epiContent}) => {
    const {
        icon,
        title,
        subtitle,
        action,
        finishButton,
        showAppLoader = false
    } = processContent;

  return (
    <div className="troubleshootingStep-main-container">
      <div className="top-container">
        {icon && <Image src={icon} alt="Error" className="error-icon" />}
        <span className="title">{title}</span>
        {subtitle && <span className="subtitle">{subtitle}</span>}
        {action}
      </div>
      {showAppLoader &&
        <Image src={Config.epiBaseUrl + epiContent.sharedPropertiesArea?.expandedValue?.[0].loadingGif.value.url} alt="Loading" className="app-loader" />
      }
      <div className="bottom-container">
        {finishButton && finishButton}
      </div>
    </div>
  );
};

export default TroubleshootingStep;
